var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"eticheta-id-sterilizare flex-center"},[_c('h1',[_vm._v(" "+_vm._s(_vm.idSterilizare)+" "),_c('br'),_vm._v(" "+_vm._s(_vm.format(new Date(), 'dd MMM, yyyy', { locale: _vm.ro }))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }